<template>
    <img class="check-animate" :src="require('./check-animate.gif')">
</template>

<script>
export default {
    name: 'check-animate'
}
</script>

<style>
.check-animate {
    height: 36px;
    width: 36px;
}
</style>